import React, { FC, useContext } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { parseISO } from 'date-fns';

// Components
import BaseContentContainer from '../../components/base-content-container/base-content-container';
import ButtonsBar from '../../components/buttons-bar/buttons-bar';
import Infos from '../../components/infos/infos';
import SubmitButton from '../../components/submit-button/submit-button';

// Helpers
import { backofficeRecipientsToEngagementRows, deleteEvent } from '../../helpers/event-helper';

// Models
import {
  BaseContentContainerActionButtonPosition,
  BaseContentContainerBiggerSide,
  BaseContentContainerFormat,
} from '../../models/base-content-container';

// Providers
import { GeneralContext } from '../../providers/general-provider';

// Services
import EventService from '../../services/event-service';

const EventFollow: FC<{
  event: BackofficeEventDetailDto;
  eventService: EventService;
}> = ({ event, eventService }) => {
  const navigate = useNavigate();
  const { eventId } = useParams<{ eventId: string }>();
  const { setModalContent, setToastContent } = useContext(GeneralContext);

  const eventData: (InfosData | EventDataDateWithPlace)[] = [
    {
      type: 'title',
      content: event.title,
    },
    {
      type: 'image',
      content: event.image?.url || null,
    },
    {
      type: 'dateWithPlace',
      startsAt: parseISO(event.startsAt.local),
      endsAt: parseISO(event.endsAt.local),
      place: event.place,
    },
    {
      type: 'text',
      content: event.description,
    },
  ];

  const engagementData: InfosDataList = {
    type: 'list',
    content: {
      titles: [
        {
          text: 'Aluno',
        },
        {
          text: 'Turma',
        },
        {
          text: 'Responsável',
        },
        {
          text: 'Visualizados',
          customStyle: { textAlign: 'center' },
        },
        {
          text: 'Respostas',
          customStyle: { textAlign: 'center' },
        },
      ],
      rows: backofficeRecipientsToEngagementRows(event.recipients),
    },
  };

  return (
    <BaseContentContainer
      format={BaseContentContainerFormat.doubleWithActionButtons}
      withoutShadowBox={true}
      biggerSide={BaseContentContainerBiggerSide.right}
      actionButtonPosition={BaseContentContainerActionButtonPosition.bottom}
    >
      <Infos
        title='evento enviado'
        titleColor='intermediate'
        data={eventData}
      />
      <Infos
        title='engajamento'
        titleColor='curiosity'
        backgroundColor='gray'
        data={engagementData}
      />
      <ButtonsBar pattern='firstSeparate' verticalAlign='bottom'>
        <Link to='/eventos/listar'>
          <SubmitButton value='cancelar' variant='terciary' />
        </Link>
        <SubmitButton
          value='deletar'
          variant='terciary'
          onClick={() =>
            deleteEvent(
              eventService,
              eventId,
              setModalContent,
              setToastContent,
              navigate
            )
          }
        />
      </ButtonsBar>
    </BaseContentContainer>
  );
};

export default EventFollow;
